import React from 'react';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer">
            <img src={`${process.env.PUBLIC_URL}/assets/layout/images/logo.png`} alt="Logo" height="20" className="mr-2" />
            <span className="font-medium ml-2">Cục Cảnh sát Quản lý hành chính về trật tự xã hội</span>
        </div>
    );
}
